import { useRef } from "react";

import { st } from "@/_helpers";

import styles from "./SwitchControlled.module.scss";


type SwitchControlledProps = {
  checked: boolean;
  setChecked?: React.Dispatch<React.SetStateAction<boolean>>;
  onChangeCallback?: () => void;
};

export default function SwitchControlled({
  checked,
  setChecked,
  onChangeCallback,
}: SwitchControlledProps) {
  return (
    <span
      className={st(
        styles.switchControlledContainer,
        checked && styles.checked
      )}
      onClick={() => {
        onChangeCallback && onChangeCallback();
        setChecked && setChecked((prev) => !prev);
      }}
    >
      <span className={styles.track} />
      <span className={styles.thumb} />
    </span>
  );
}

type SwitchUnControlledProps = {
  checked?: boolean;
  name?: string;
  onChangeCallback?: () => void;
};

export function SwitchControlledInput({
  checked = false,
  name = "",
  onChangeCallback,
}: SwitchUnControlledProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <label htmlFor={name}>
      <input
        ref={inputRef}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChangeCallback}
        hidden
      />
      <span
        className={st(
          styles.switchControlledContainer,
          checked && styles.checked
        )}
        onClick={() => {
          inputRef.current?.click();
        }}
      >
        <span className={styles.track} />
        <span className={styles.thumb} />
      </span>
    </label>
  );
}
